<template>
  <div class="p-users-teams g-page">
    <VLowEnvelopeAllowanceWarning ec="users_and_teams" />
    <VTabs>
      <div slot="users" :title="$t('users.title')" icon="user">
        <VDynamicLoader viewURL="users/Users" />
      </div>
      <div slot="teams" :title="$t('teams.title')" class="groups-tab">
        <VDynamicLoader viewURL="users/Groups" />
      </div>
    </VTabs>
  </div>
</template>

<script>
import VTabs from '@/components/deprecated/molecules/Tabs.vue';
import VLowEnvelopeAllowanceWarning from '@/views/components/LowEnvelopeAllowanceWarning.vue';
import VDynamicLoader from '@/components/DynamicLoader.vue';

export default {
  name: 'UsersAndTeams',
  components: {
    VTabs,
    VLowEnvelopeAllowanceWarning,
    VDynamicLoader,
  },
};
</script>
